module.exports = __webpack_public_path__ + "c293bf120df6f9aefbb8be4317b28643.gif";